/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Embeddings_Balance_InfoInputs */

const es_admin_company_overview_embeddings_balance_info = /** @type {(inputs: Admin_Company_Overview_Embeddings_Balance_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad utilizada para analizar e indexar los archivos que subís, permitiendo que Nexy entienda su contenido y pueda buscar información dentro de ellos.`)
};

const en_admin_company_overview_embeddings_balance_info = /** @type {(inputs: Admin_Company_Overview_Embeddings_Balance_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing capacity used to analyze and index your uploaded files so Nexy can understand and search their content.`)
};

/**
* | output |
* | --- |
* | "Processing capacity used to analyze and index your uploaded files so Nexy can understand and search their content." |
*
* @param {Admin_Company_Overview_Embeddings_Balance_InfoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_embeddings_balance_info = /** @type {((inputs?: Admin_Company_Overview_Embeddings_Balance_InfoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Embeddings_Balance_InfoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_embeddings_balance_info(inputs)
	return en_admin_company_overview_embeddings_balance_info(inputs)
});
export { admin_company_overview_embeddings_balance_info as "admin.company_overview.embeddings_balance_info" }